module.exports = __webpack_public_path__ + "1265d99c408f3846750c8422865dc825.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/awana.png
// module id = 585
// module chunks = 0